import { currentOrigin, DEFAULT_AUTHENTICATED_ROUTE } from "./config"

export function sanitizeDashboardReturnTo(value: string | undefined): string {
  if (!value) return DEFAULT_AUTHENTICATED_ROUTE
  try {
    const parsed = new URL(value, currentOrigin())
    if (parsed.origin !== currentOrigin()) return DEFAULT_AUTHENTICATED_ROUTE
    const returnTo = `${parsed.pathname}${parsed.search}${parsed.hash}`
    if (returnTo === "/" || returnTo === "/login" || returnTo.startsWith("/auth/callback")) {
      return DEFAULT_AUTHENTICATED_ROUTE
    }
    return returnTo || DEFAULT_AUTHENTICATED_ROUTE
  } catch {
    return DEFAULT_AUTHENTICATED_ROUTE
  }
}

export function buildDashboardReturnTo(url: URL): string {
  return `${url.pathname}${url.search}${url.hash}`
}

export function currentDashboardReturnTo() {
  if (typeof window === "undefined") return DEFAULT_AUTHENTICATED_ROUTE
  return buildDashboardReturnTo(new URL(window.location.href))
}

export function redirectToDashboardLogin(returnTo = currentDashboardReturnTo()) {
  if (typeof window === "undefined") return
  window.location.assign(dashboardLoginUrl(returnTo))
}

export function dashboardLoginUrl(returnTo = currentDashboardReturnTo()) {
  return `/login?returnTo=${encodeURIComponent(sanitizeDashboardReturnTo(returnTo))}`
}
